import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, NO_ERRORS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-list-with-tag',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA],
  templateUrl: './list-with-tag.component.html',
  styleUrl: './list-with-tag.component.scss'
})
export class ListWithTagComponent {
  @Input() isHeadingAvailable: boolean = false;
  @Input() heading!: string;
  @Input() listItems: string[] = [];
  @Input() listTag: string = 'ul';
  @Input() liType?: string;
  @Input() cssClass!: string;


  constructor() {

  }

}
